import React from 'react';
import { NoticeFormType } from '../../types/notices';
import {
  ActionPlanPreview,
  ActionReportPreview,
  EventInvitePreview,
  GeneralExpenseReportPreview,
  MeetingMinutesPreview,
  TravelExpenseReportPreview,
} from '../forms';
import { EventFormType } from '../../types/events';
import { FlexColumn } from '../../components/basic/Flex';
import { Divider } from '../../components/common/Divider';
import { FormContainer } from './layoutComponents';
import { ExpenseReportFormType } from '../../types/expense-reports';
import { Form } from '../../types/forms';

const renderPreview = (form: Form) => {
  switch (form.formType) {
    case NoticeFormType.ActionPlan:
      return <ActionPlanPreview formData={form.formData} />;
    case NoticeFormType.ActionReport:
      return <ActionReportPreview formData={form.formData} />;
    case NoticeFormType.MeetingMinutes:
      return <MeetingMinutesPreview formData={form.formData} />;
    case EventFormType.EventInvite:
      return <EventInvitePreview formData={form.formData} />;
    case ExpenseReportFormType.GeneralExpenseReport:
      return <GeneralExpenseReportPreview formData={form.formData} signedUrls={form.signedUrls} />;
    case ExpenseReportFormType.TravelExpenseReport:
      return <TravelExpenseReportPreview formData={form.formData} signedUrls={form.signedUrls} />;
  }
};

interface FormDetailsProps {
  form: Form;
}

const FormDetails: React.FC<FormDetailsProps> = ({ form, children }) => {
  return (
    <FormContainer>
      <FlexColumn gap="16px">
        <FlexColumn>{renderPreview(form)}</FlexColumn>
        <Divider />
        {children}
      </FlexColumn>
    </FormContainer>
  );
};

export default FormDetails;
